import { API2_HOST } from '@/utils/constants';

import fetchData from './http';
import { IBaseResponse } from './types/common';

export const updateSubscribe = (params: any) => {
  // 取消订阅, type(1-5,1:发送频率过高;2:内容不感兴趣;3:设计不好看;4:垃圾邮件;5:其他类型)
  const url = `${API2_HOST}/s1/mailing-subscription/email/unsubscribe/confirm`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<any>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result as any);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

export const getSubscribe = () => {
  const url = `${API2_HOST}/s1/mailing-subscription/email/unsubscribe/check`;
  return new Promise((resolve, reject) => {
    fetchData
      .get<IBaseResponse<any>>(url)
      .then((res) => {
        resolve(res.result as any);
      })
      .catch((error: any) => {
        reject(error.response ? error.response.data : error);
      });
  });
};
